import { Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Subscription } from '../data/subscription';
import { FordService } from '../services/ford.service';
import { PriceTier } from '../data/price-tier';
import { PriceTierService } from '../services/price-tier.service';
import { Dealer, DealerCurrent, DealerStatus } from '../data/dealer';
import { Price } from '../data/price';
import { DealerService } from '../services/dealer.service';
import { AccountInfoService } from '../services/account.service';
import { FuncsService } from '../services/funcs.service';
import { InternationalRequest } from '../data/international-request';
import { InternationalRequestService } from '../services/international-request.service';
import { CustomerCurrent } from '../data/customer';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-status-enrolled',
  templateUrl: './status-enrolled.component.html',
  styleUrls: ['./status-enrolled.component.css'],
  standalone: false
})
export class StatusEnrolledComponent {
  sub: Subscription = {
    createdAt: "",
    startDate: "",
    siteCode: "",
    maxAllowedUniqueDealerTechnicianLogins: 0,
    concurrentSessions: 0,
    expiresAt: "",
    status: 200
  };

  prices: Price = {
    per_tech: 0,
    monthly: 0,
    can_price: 0,
    can_monthly: 0
  };

  fleetPrices: Price = {
    per_tech: 0,
    monthly: 0,
    can_price: 0,
    can_monthly: 0
  };

  public loading = true;
  public price = 0;
  public monthly = 0;
  public fleetPrice = 0;
  public fleetMonthly = 0;
  public enrolled = "";
  public international = false;
  public isApa = false;
  public fleet = false;

  dealer: Dealer = DealerCurrent;
  dealerStatus: DealerStatus = <DealerStatus>{};
  priceTiers: PriceTier[] = [];
  canadaPriceTiers: PriceTier[] = [];
  fleetPriceTiers: PriceTier[] = [];
  subscribed: boolean = false;
  dueToExpire: boolean = false;
  tech_count: number = 0;
  pendingRequests: InternationalRequest[] = [];
  admin: boolean = false;

  selectedBillingType: string = "";

  constructor(
    private internationalRequestService: InternationalRequestService,
    private dealerService: DealerService,
    private fordService: FordService,
    private priceTierService: PriceTierService,
    private fleetBillingService: AccountInfoService,
    private funcs: FuncsService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ref: any;

  ngOnInit(): void {
    this.admin = this.funcs.isAdmin();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.getDealerStatus();
      });

    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      }
    });
    if (this.ref == "fleet" || CustomerCurrent.role === "FLEET") {
      this.fleet = true;
    }
    this.dealerStatus.tech_count = 0;
    this.funcs.currentDealer(this.dealer);
    // this.getSubscription();
    this.getDealerStatus();
    this.loading = true;
    this.getFleetBillingStatus(this.getUsername(this.dealer.pa_code));
  }

  dateFormat(dateString: string): string {
    return this.funcs.dateFormat(dateString);
  }

  retry(): void {
    // this.getSubscription();
    this.getDealerStatus();
    this.loading = true;
  }

  isApaCountry(c: string) {
    var apa_countries = ["AGO", "ARE", "ASM", "AUS", "BEN", "BFA", "BGD", "BHR", "BRN", "BWA", "CIV", "CMR", "CPV", "DJI", "EGY", "ETH", "FJI", "GHA", "GIN", "GMB", "GNB", "GUM", "HKG", "IDN", "IND", "IRQ", "ISR", "JOR", "JPN", "KHM", "KOR", "KWT", "LAO", "LBN", "LBR", "LKA", "MAR", "MDG", "MHL", "MNG", "MNP", "MOZ", "MUS", "MWI", "MYS", "NAM", "NCL", "NGA", "NPL", "NZL", "OMN", "PHL", "PNG", "PYF", "QAT", "SAU", "SWZ", "SYC", "THA", "TUN", "TZA", "UGA", "VNM", "VUT", "WLF", "YEM", "ZAF", "ZIM", "ZMB"];
    return apa_countries.indexOf(c) >= 0;
  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else {
      username = `FCT${pa_code}`
    }

    return username;
  }

  getDealerStatus(): void {
    var dealerCountry = "";

    forkJoin({
      priceTiers: this.priceTierService.getPriceTiers(),
      canadaPriceTiers: this.priceTierService.getCanadaPriceTiers(),
      fleetPriceTiers: this.priceTierService.getFleetPriceTiers()
    }).subscribe(({ priceTiers, canadaPriceTiers, fleetPriceTiers }) => {
      this.priceTiers = priceTiers;
      this.canadaPriceTiers = canadaPriceTiers;
      this.fleetPriceTiers = fleetPriceTiers;

      this.priceTiers = this.priceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });
      this.priceTiers.forEach(pt => {
        if (pt.qty <= this.dealer.tech_count) {
          this.prices.per_tech = pt.price;
          // this.prices.can_price = pt.price_canadian_dollar;
        }
      });

      this.canadaPriceTiers = this.canadaPriceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });
      this.canadaPriceTiers.forEach(cpt => {
        if (cpt.qty <= this.dealer.tech_count) {
          this.prices.can_price = cpt.price_canadian_dollar;
        }
      });

      this.fleetPriceTiers = this.fleetPriceTiers.sort((a, b) => {
        return a.qty - b.qty;
      });

      this.fleetPriceTiers.forEach(fpt => {
        if (fpt.qty <= this.dealer.tech_count) {
          this.fleetPrices.per_tech = fpt.price;
          this.fleetPrices.can_price = fpt.price_canadian_dollar;
        }
      });
    });

    const dealerStatusData = this.dealerService.getSingleDealerStatus(this.getUsername(this.dealer.pa_code));

    var reCountryPrefix = /^[A-z]{3}/i;
    if (!reCountryPrefix.test(this.dealer.pa_code) && CustomerCurrent.pa_code === this.dealer.pa_code) {
      this.dealer.pa_code = CustomerCurrent.country3 + this.dealer.pa_code;
      DealerCurrent.pa_code = this.dealer.pa_code;
    }

    const subscriptionData = this.fordService.getSubscription(this.dealer.pa_code);

    forkJoin([dealerStatusData, subscriptionData]).subscribe(responses => {
      this.dealerStatus = responses[0];
      if (responses[1].siteCode) {
        this.sub = responses[1];
        if (!this.sub.maxAllowedUniqueDealerTechnicianLogins) {
          this.sub.maxAllowedUniqueDealerTechnicianLogins = 0;
        }
        // this.subscribed = true;
        this.subscribed = this.funcs.isSubscribed(responses[1]);
        this.dueToExpire = this.funcs.isDueToExpire(responses[1]);
      } else {
        this.subscribed = false;
      }

      dealerCountry = this.funcs.getThreeLetterCountry(this.dealer.pa_code);
      this.isApa = this.isApaCountry(dealerCountry);
      this.international = dealerCountry !== "USA" && dealerCountry !== "CAN";
      if (this.sub.concurrentSessions != 5 && !this.international) {
        this.sub.concurrentSessions = 5;
      }

      // if (this.fleet) {
      //   this.internationalRequestService.getInternationalRequestsByStatus(201, this.dealer.pa_code).subscribe(iReq => {          
      //     iReq.forEach(req => {
      //       this.sub.maxAllowedUniqueDealerTechnicianLogins = req.license_qty_requested;
      //     });
      //   });
      // }

      if (this.international) {
        // look for subscriber requests pending approval
        // console.log("international queue check");
        this.internationalRequestService.getInternationalRequestsByStatus(101, this.dealer.pa_code).subscribe(iReq => {
          // this.loading = false;
          // console.log("international queue check - returned");
          // console.log(iReq);
          this.pendingRequests = iReq;
        });
      }

      if (!this.subscribed) {
        if (this.sub.maxAllowedUniqueDealerTechnicianLogins == null || this.sub.maxAllowedUniqueDealerTechnicianLogins == 0) {
          this.sub.maxAllowedUniqueDealerTechnicianLogins = this.dealerStatus.tech_count == null ? 0 : this.dealerStatus.tech_count;
        }
      }

      if (dealerCountry === "CAN") {
        this.dealerStatus.tech_count = this.dealerStatus.tech_count == null ? this.sub.maxAllowedUniqueDealerTechnicianLogins : this.dealerStatus.tech_count;

        this.prices.can_monthly = (this.prices.can_price * this.dealerStatus.tech_count) / 12;
        this.fleetPrices.can_monthly = (this.fleetPrices.can_price * this.sub.maxAllowedUniqueDealerTechnicianLogins) / 12;

        if (this.fleet) {
          this.fleetPrice = this.fleetPrices.can_price;
          this.fleetMonthly = this.fleetPrices.can_monthly;
        } else {
          this.price = this.prices.can_price;
          this.monthly = this.prices.can_monthly;
        }
      } else if (dealerCountry === "USA") {
        this.dealerStatus.tech_count = this.dealerStatus.tech_count == null ? this.sub.maxAllowedUniqueDealerTechnicianLogins : this.dealerStatus.tech_count;

        this.prices.monthly = (this.prices.per_tech * this.dealerStatus.tech_count) / 12;
        this.fleetPrices.monthly = (this.fleetPrices.per_tech * this.sub.maxAllowedUniqueDealerTechnicianLogins) / 12;

        if (this.fleet) {
          this.fleetPrice = this.fleetPrices.per_tech;
          this.fleetMonthly = this.fleetPrices.monthly;
        } else {
          this.price = this.prices.per_tech;
          this.monthly = this.prices.monthly;
        }
      }
      this.loading = false;
    });
  }

  getFleetBillingStatus(username: string) {
    this.fleetBillingService.getFleetDetails(username).subscribe(details => {      
      this.selectedBillingType = details.billingType || "Monthly";
    })
  }

  transform(value: string): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  /*getSubscription(): void {
    this.fordService.getSubscription(this.dealer.pa_code).subscribe(sub => {
      // var now: Date = new Date();
      if (!sub.startDate) {
        sub.startDate = (new Date(0)).toISOString();
      }
      if (!sub.expiresAt) {
        sub.expiresAt = (new Date(0)).toISOString();
      }
      if (!sub.maxAllowedUniqueDealerTechnicianLogins) {
        sub.maxAllowedUniqueDealerTechnicianLogins = 0;
      }
      if (!sub.concurrentSessions) {
        sub.concurrentSessions = 0;
      }
      this.sub = sub;

      this.priceTierService.getPriceTiers().subscribe(priceTiers => {
        this.priceTiers = priceTiers;
        this.priceTiers = this.priceTiers.sort((a, b) => {
          return a.qty - b.qty;
        });

        this.priceTiers.forEach(pt => {
          if (pt.qty < this.dealer.tech_count) {
            this.prices.per_tech = pt.price;
          }
        });
        this.prices.monthly = this.prices.per_tech * this.sub.maxAllowedUniqueDealerTechnicianLogins / 12;
        this.loading = false;
      });

      this.subscribed = this.funcs.isSubscribed(sub);
      this.international = this.funcs.getThreeLetterCountry(sub.siteCode) !== "USA" && this.funcs.getThreeLetterCountry(sub.siteCode) !== "CAN";
      // console.log(sub.siteCode);
      this.isApa = this.isApaCountry(this.funcs.getThreeLetterCountry(sub.siteCode));

      if (!this.subscribed && this.funcs.getThreeLetterCountry(sub.siteCode) === 'USA' || this.funcs.getThreeLetterCountry(sub.siteCode) === 'CAN') {
        // get our tech count
        this.dealerService.getDealer(this.funcs.stripCountry(sub.siteCode)).subscribe({
          next: (d)=> {
            this.tech_count = (d) ? d.tech_count : 0;
          },
          error: (err)=> this.tech_count = 0,
          complete: ()=> console.log(this.tech_count)
        });
      } else {
        this.tech_count = sub.maxAllowedUniqueDealerTechnicianLogins;
      }
      this.enrolled = new Date(this.sub.createdAt).toDateString();

      if (this.international) {
        // look for subscriber requests pending approval
        this.internationalRequestService.getInternationalRequestsByStatus(101, this.dealer.pa_code).subscribe(iReq => {
          // this.loading = false;
          this.pendingRequests = iReq;
        });
      }
    });
  }*/
}
